import { StyleSheet } from "react-native";

const globalStyles = StyleSheet.create({
    ePaperSelectorButton : {
        width: '100%',
        backgroundColor: '#fff',
        borderWidth: 2,             
        borderColor: '#069',         
        borderStyle: 'solid',
        borderRadius: 8,
        alignItems: 'center',
    },
    ePaperSelectorinfo : {
        color:'#777',
        fontSize: 20,
        fontWeight:'bold',
        alignSelf:'center',
        margin:0,
    },
    ePaperSelectorinfoSmall : {
        color:'#777',
        fontSize: 16,
        alignSelf:'center',
        margin:0,
    },
    ePaperSelectorImage : {  
        width: '100%',
        aspectRatio: 'auto 1499 / 1119',
        overflow: 'hidden',
    },    
    ePaperSelectorDeleteButton : {
        width: '100%',
        padding: 5,
        backgroundColor: '#a00',
        borderRadius: 8,
        alignItems: 'center',
    },
    ePaperSelectorDeleteButtonText : {
        color: "#eee", 
        fontSize: 16,
        fontWeight:'bold',
        alignSelf:'center',
        margin:1,
    },
});

export default globalStyles;